// import template from './template.html';
import controller from './controller';
export default {
  restrict: 'E',
  bindings: {},
  template: '<div ng-include="$ctrl.tpl"></div>',
  controller
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/index.js
 **/